<template>
  <div
    v-if="text"
    class="break-with-text-container"
  >
    <div class="half-length-break" />
    <span class="p6 text">{{ text }}</span>
    <div class="half-length-break" />
  </div>
  <hr
    v-else
    class="full-length-break"
  >
</template>

<script>
export default {
  name: 'DpplPageBreak',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.break-with-text-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.half-length-break {
  height: 1px;
  background-color: rgba(31, 45, 67, 0.3);
  width: 50%;
}

.text {
  color: fade(@text-darkest, 30%);
  padding: 0px 5px;
}

.full-length-break {
  border: none;
  height: 1px;
  background-color: rgba(31, 45, 67, 0.3);
  width: 100%;
}
</style>
